import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Skeleton Component - Loading placeholder with shimmer animation
 * @ownyou/ui-components
 */
import { cn } from '@ownyou/ui-design-system';
function toStyleValue(value) {
    if (value === undefined)
        return undefined;
    return typeof value === 'number' ? `${value}px` : value;
}
function SkeletonLine({ width, height, shimmer, className, style, ...rest }) {
    return (_jsx("div", { className: cn('bg-neutral-200 rounded h-4', shimmer && 'animate-pulse', className), style: {
            width: toStyleValue(width),
            height: toStyleValue(height),
            ...style,
        }, "data-testid": "skeleton", ...rest }));
}
export function Skeleton({ variant = 'text', width, height, lines = 1, shimmer = true, className, style, ...rest }) {
    if (variant === 'text') {
        if (lines > 1) {
            return (_jsx("div", { className: cn('flex flex-col gap-2', className), "data-testid": "skeleton-group", ...rest, children: Array.from({ length: lines }, (_, i) => (_jsx(SkeletonLine, { width: i === lines - 1 ? '75%' : width, height: height, shimmer: shimmer }, i))) }));
        }
        return (_jsx(SkeletonLine, { width: width, height: height, shimmer: shimmer, className: className, style: style, ...rest }));
    }
    if (variant === 'circular') {
        return (_jsx("div", { className: cn('bg-neutral-200 rounded-full', shimmer && 'animate-pulse', !width && !height && 'w-10 h-10', className), style: {
                width: toStyleValue(width),
                height: toStyleValue(height ?? width),
                ...style,
            }, "data-testid": "skeleton", ...rest }));
    }
    if (variant === 'rectangular') {
        return (_jsx("div", { className: cn('bg-neutral-200 rounded', shimmer && 'animate-pulse', !width && 'w-full', !height && 'h-24', className), style: {
                width: toStyleValue(width),
                height: toStyleValue(height),
                ...style,
            }, "data-testid": "skeleton", ...rest }));
    }
    if (variant === 'card') {
        return (_jsxs("div", { className: cn('flex flex-col gap-2', className), "data-testid": "skeleton-card", ...rest, children: [_jsx("div", { className: cn('bg-neutral-200 rounded', shimmer && 'animate-pulse', 'w-full h-32'), "data-testid": "skeleton" }), _jsx(SkeletonLine, { shimmer: shimmer }), _jsx(SkeletonLine, { shimmer: shimmer }), _jsx(SkeletonLine, { shimmer: shimmer, width: "75%" })] }));
    }
    return null;
}
export default Skeleton;
